import { kbSentenceItem } from '../lib/models/interfaces';

export const getKMFilters = (kbSentebces: kbSentenceItem[]) => {
  const initialFullList = kbSentebces.map((ele) => ele.knowledge_base_type);
  const uniqueSet = Array.from(new Set(initialFullList));
  return uniqueSet;
};
